<script lang="ts">
  import Logo from "../atoms/Logo.svelte";
  import Link from "../atoms/Link.svelte";
  import PopupReturn from "./PopupReturn.svelte";

  interface Props {
    campaign: string;
  }

  let { campaign }: Props = $props();

  let showBack = $state(false);
  const togglePopup = () => {
    showBack = !showBack;
  };
</script>

<nav class="w-full mb-2 sm:mb-6 md:mb-12 bg-Neutral110 flex justify-center">
  <ul
    class="flex items-center justify-between w-full lg:max-w-grid h-12 lg:h-22 py-2 lg:py-3 lg:mx-16 border-b-1 border-TextGrey px-3"
  >
    <li class=" w-26 lg:w-42 h-7.5 lg:h-full lg:py-1">
      <button onclick={togglePopup}>
        <Logo />
      </button>
    </li>
    <li>
      <Link class="font-bold" onClick={togglePopup}>Tillbaka till hemsidan</Link>
    </li>
  </ul>
</nav>
{#if showBack}
  <PopupReturn {campaign} onCancel={() => (showBack = false)} />
{/if}
